import * as React from "react";
import { inject, observer } from "mobx-react";
import { withRouter, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

@inject("store")
@observer
export default class MarketSelectorPanel extends React.Component {
    constructor(props) {
        super(props);
        //this.state = {
        //    marketSelectorOpen: false
        //}

        this.closeMarketSelector = this.closeMarketSelector.bind(this);
        this.state = { marketSelectorOpen: false }
        this.marketSelector = React.createRef();
        this.addMarketCloseEvent = this.addMarketCloseEvent.bind(this);
        this.handleClickOutsideMarket = this.handleClickOutsideMarket.bind(this);

        this.changeSite = this.changeSite.bind(this);
        this.openExternalUrl = this.openExternalUrl.bind(this);


    }




    changeSite(e, url) {
        e.preventDefault();
        window.location = url;
    }

    addMarketCloseEvent() {
        document.addEventListener('mousedown', this.handleClickOutsideMarket);
    }

    handleClickOutsideMarket(event) {
        if (this.marketSelector && !this.refs.marketSelectorClose === event.target) {
            document.removeEventListener('mousedown', this.handleClickOutsideMarket);
            //this.setState({
            //    marketSelectorOpen: false
            //});
            const navigation = this.props.store.navigation;
            navigation.setMarketSelectorVisible(false);
        }
    }



    closeMarketSelector(event) {
        if (event.target === this.refs.marketSelectorClose) {
            //this.props.openState(false);
            //this.setState({
            //    marketSelectorOpen: false
            //});
            const navigation = this.props.store.navigation;
            navigation.setMarketSelectorVisible(false);
        }

    }

    openExternalUrl(e, url) {
        const navigation = this.props.navigation;
        e.preventDefault();
        if (confirm(navigation.dictionary.ExternalLinkYouAreAboutToLeave + "\n\n" + url + "\n\n" + navigation.dictionary.ExternalLinkAreYouSure)) {
            window.location.href = url;
        }
    }

    componentDidMount() {
        window.addEventListener("click", this.closeMarketSelector);
    }

    componentDidUpdate() {
        //const state = this.props.marketSelectorOpen || this.props.store.navigation.marketSelectorOpen;
        //console.log("marketSelector->", state);
        //if (state !== this.state.marketSelectorOpen) {
        //    this.setState({ marketSelectorOpen: this.props.marketSelectorOpen });
        //}
    }

    groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, []);
    }

    render() {

        const navigation = this.props.navigation;
        var currentState = this.props.store.navigation.marketSelectorOpen; // trigger update

        var regions = this.groupBy(navigation.mainTree.Countries, "CountryGroup");

        for (let regionKey of Object.keys(regions)) {
            var colNum = 4;
            var total = regions[regionKey].length;

            var itemsPerColumn = Math.ceil(total / colNum);
            //console.log("total:", total, "colNum", itemsPerColumn);
            var groups = [];
            var columnCount = 0;
            var column = [];
            groups.push(column);
            for (var obj of regions[regionKey]) {
                column.push(obj);
                columnCount++;
                if (columnCount >= itemsPerColumn) {
                    columnCount = 0;
                    column = [];
                    groups.push(column);
                }
            }
            regions[regionKey] = {
                RegionName: regionKey, Groups: groups

            }
        }

        if (currentState) {
            return (<React.Fragment>
                <div ref="marketSelectorClose" className="sortOptionsOutside"></div>
                <div className="market-selector-list" ref="marketSelectorList">
                    <div className="container-fluid market-selector-wrapper">
                        <React.Fragment>
                            {//<h3 className="market-selector-heading">{navigation.dictionary.ChooseCountry}</h3>
                            }
                            {Object.values(regions).map(region => {
                                return (
                                    <React.Fragment key={region.RegionName}>
                                        {regions.length > 1 && <h4>{region.RegionName}</h4>}
                                        <div className="row market-row">
                                            {region.Groups.map((group, groupIndex) => {
                                                return (
                                                    <div key={groupIndex} className="col-lg-3 col-md-4 col-12">
                                                        <ul>
                                                            {group.map(country => {
                                                                return (
                                                                    <li
                                                                        key={country.CountryCode}>
                                                                        {country.ExternalUrl
                                                                            ? <React.Fragment>
                                                                                <span className="country-flag" ><img src={
                                                                                    "/dist/img/flags/" + country.CountryCode + ".svg"} alt={country.CountryCode} /></span>
                                                                                <a
                                                                                    target="_blank"
                                                                                    href={country.ExternalUrl}
                                                                                    onClick={(e) => this
                                                                                        .openExternalUrl(e,
                                                                                            country.ExternalUrl)
                                                                                    }
                                                                                >{country.CountryName
                                                                                    } <FontAwesomeIcon icon={[
                                                                                        "fas", "external-link-alt"
                                                                                    ]} className="country-external-link-icon" /></a>

                                                                            </React.Fragment>
                                                                            : country.LanguageUrls.length > 1
                                                                                ? <React.Fragment>
                                                                                    <span className="country-flag" ><img src={
                                                                                        "/dist/img/flags/square4x3/" + country.CountryCode + ".svg"} alt={country.CountryCode} /></span>
                                                                                    {country.CountryName
                                                                                    }<span className="market-divider">-</span>
                                                                                    {country.LanguageUrls.map(
                                                                                        page => {
                                                                                            const
                                                                                                languageMarket =
                                                                                                    page
                                                                                                        .LanguageCode +
                                                                                                    "-" +
                                                                                                    country
                                                                                                        .MarketCode;
                                                                                            return (<a
                                                                                                key={page.HrefLang}
                                                                                                href={page.FullUrl()
                                                                                                }
                                                                                                onClick={(e) =>
                                                                                                    this.changeSite(
                                                                                                        e,
                                                                                                        page
                                                                                                            .FullUrl() +
                                                                                                        "?switchstore=" +
                                                                                                        languageMarket +
                                                                                                        "&country=" +
                                                                                                        country
                                                                                                            .CountryCode)
                                                                                                }
                                                                                            >{page.HrefLang
                                                                                                .substr(0, 2)
                                                                                                .toUpperCase()}</a>
                                                                                            );
                                                                                        })}
                                                                                </React.Fragment>
                                                                                : <React.Fragment>
                                                                                    <span className="country-flag" ><img src={
                                                                                        "/dist/img/flags/square4x3/" + country.CountryCode + ".svg"} alt={country.CountryCode} /></span>
                                                                                    <a
                                                                                        href={country
                                                                                            .LanguageUrls[0]
                                                                                            .FullUrl()}
                                                                                        onClick={(e) =>
                                                                                            this.changeSite(e,
                                                                                                country
                                                                                                    .LanguageUrls[0]
                                                                                                    .FullUrl() +
                                                                                                "?switchstore=" +
                                                                                                country
                                                                                                    .LanguageUrls[0]
                                                                                                    .LanguageCode +
                                                                                                "-" +
                                                                                                country
                                                                                                    .MarketCode +
                                                                                                "&country=" +
                                                                                                country
                                                                                                    .CountryCode)}
                                                                                    >{country.CountryName}</a>
                                                                                </React.Fragment>
                                                                        }
                                                                    </li>
                                                                );
                                                            }
                                                            )}
                                                        </ul>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </React.Fragment>
                                );
                            })}
                        </React.Fragment>
                    </div>
                </div>
            </React.Fragment>
            );
        } else {
            return (null);
        }



    }
}